import { ref } from '@vue/composition-api'

import InvoicingService from '@services/InvoicingService'

// LIQ-2656: the values the Invoicing page's TPA / Lead Underwriter / CCY
// multi-select filters offer, fetched once per visit to the Invoicing page
// and shared by the Invoice and Itemized views. InvoicingTab resets the
// cache when it mounts, so each visit sees values added since the last one.
// Created on first use, not at import: the router imports this module before
// main.js runs Vue.use(VueCompositionAPI), and a module-level ref() then
// crashes the app on load ("undefined is not an object (evaluating
// 'n.observable')").
let options = null
let request = null

// Joins a multi-select filter's picked values into one query param value -
// names can contain commas, so the backend splits on '|'.
export const MULTI_VALUE_SEPARATOR = '|'

// Drop the cached options so the next useInvoiceFilterOptions() refetches.
export function resetInvoiceFilterOptions() {
  request = null
}

export default function useInvoiceFilterOptions() {
  if (!options) options = ref({ tpa_name: [], managing_agent: [], currency_type: [] })
  if (!request) {
    const current = InvoicingService.getFilterOptions()
      .then((resp) => {
        // A reset while this was in flight means a newer visit owns the cache.
        if (request !== current) return
        const data = (resp && resp.data && resp.data.data) || {}
        options.value = {
          tpa_name: data.tpa_names || [],
          managing_agent: data.managing_agents || [],
          currency_type: data.currency_types || [],
        }
      })
      .catch((e) => {
        console.error('Failed to load invoice filter options:', e)
        if (request === current) request = null
      })
    request = current
  }
  return options
}
